import { CancelTokenSource } from 'axios';
import {
  FieldValidationErrorDto,
  InterventionInvoicePrice,
  ProductDto,
  ProductItemDto,
  ProductSearchRequest,
  SpecialCaseProductRequestDto,
  UpsertProductDto
} from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/product`;

export const fetchAllProducts = (
    withDeleted: boolean,
    source: CancelTokenSource): Promise<ProductDto[]> => {

  return axios
      .get(`${apiUri}/all`, {params: {withDeleted: withDeleted}, cancelToken: source.token})
      .then(response => response.data)
};

export const searchProducts = (
    productsSearchRequest: Partial<ProductSearchRequest>,
    source: CancelTokenSource): Promise<Array<ProductDto>> => {

  return axios
      .post(`${apiUri}/search`, productsSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
}

export const findProductById = (
    id: string, source: CancelTokenSource): Promise<UpsertProductDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const addProduct = (
    upsertProductDto: Partial<UpsertProductDto>,
    source: CancelTokenSource): Promise<ProductDto> => {

  return axios
      .post(apiUri, upsertProductDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editProduct = (
    id: string,
    upsertProductDto: Partial<UpsertProductDto>,
    source: CancelTokenSource): Promise<ProductDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertProductDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteProduct = (
    id: string, source: CancelTokenSource): Promise<string> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const getProductPrice = (
    productDto: Partial<ProductDto>,
    source: CancelTokenSource): Promise<InterventionInvoicePrice> => {

  return axios
      .post(`${apiUri}/product-price`, productDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const checkProcedureGroups = (
    request: Partial<ProductItemDto>,
    source: CancelTokenSource): Promise<FieldValidationErrorDto[]> => {

  return axios
      .post(`${apiUri}/item/check-procedure-groups`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllSpecialCaseProducts = (
    source: CancelTokenSource): Promise<{ [index: string]: string }> => {

  return axios
      .get(`${apiUri}/special-case-product`, {cancelToken: source.token})
      .then(response => response.data);
};

export const saveSpecialCaseProduct = (
    request: Partial<SpecialCaseProductRequestDto>,
    source: CancelTokenSource): Promise<string> => {

  return axios
      .post(`${apiUri}/special-case-product`, request, {cancelToken: source.token})
      .then(response => response.data);
};
